import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 个人信息面板
 *
 * 用户中心默认展示的个人信息 section 内容。
 */
import * as React from 'react';
import { ProfileIcon, SettingsIcon, ShieldIcon } from './icons.js';
/** 个人信息面板组件 */
export function ProfilePanel() {
    return (_jsxs("div", { style: styles.panel, children: [_jsxs("div", { style: styles.header, children: [_jsx("div", { style: styles.avatarWrapper, children: _jsx("div", { style: styles.avatar, children: _jsx(ProfileIcon, {}) }) }), _jsxs("div", { style: styles.userInfo, children: [_jsx("h2", { style: styles.username, children: "\u7528\u6237\u540D" }), _jsx("p", { style: styles.userEmail, children: "user@example.com" }), _jsx("span", { style: styles.badge, children: "\u666E\u901A\u7528\u6237" })] })] }), _jsxs("div", { style: styles.infoSection, children: [_jsxs("h3", { style: styles.sectionTitle, children: [_jsx("span", { style: styles.sectionIcon, children: "\uD83D\uDCCB" }), "\u57FA\u672C\u4FE1\u606F"] }), _jsxs("div", { style: styles.infoGrid, children: [_jsx(InfoItem, { label: "\u7528\u6237\u540D", value: "\u5F85\u63A5\u5165" }), _jsx(InfoItem, { label: "\u90AE\u7BB1", value: "\u5F85\u63A5\u5165" }), _jsx(InfoItem, { label: "\u624B\u673A\u53F7", value: "\u5F85\u63A5\u5165" }), _jsx(InfoItem, { label: "\u6CE8\u518C\u65F6\u95F4", value: "2024-01-01" }), _jsx(InfoItem, { label: "\u6700\u540E\u767B\u5F55", value: "2026-10-02" }), _jsx(InfoItem, { label: "\u8D26\u53F7\u72B6\u6001", value: "\u6B63\u5E38", status: "active" })] })] }), _jsxs("div", { style: styles.actionSection, children: [_jsxs("h3", { style: styles.sectionTitle, children: [_jsx("span", { style: styles.sectionIcon, children: "\u26A1" }), "\u5FEB\u6377\u64CD\u4F5C"] }), _jsxs("div", { style: styles.actionGrid, children: [_jsx(ActionCard, { icon: _jsx(SettingsIcon, {}), title: "\u8D26\u53F7\u8BBE\u7F6E", description: "\u4FEE\u6539\u5BC6\u7801\u3001\u7ED1\u5B9A\u624B\u673A", color: "#6366f1" }), _jsx(ActionCard, { icon: _jsx(ShieldIcon, {}), title: "\u5B89\u5168\u4E2D\u5FC3", description: "\u767B\u5F55\u8BBE\u5907\u7BA1\u7406", color: "#10b981" })] })] })] }));
}
/** 信息条目组件 */
function InfoItem({ label, value, status }) {
    return (_jsxs("div", { style: styles.infoItem, children: [_jsx("span", { style: styles.infoLabel, children: label }), _jsxs("span", { style: {
                    ...styles.infoValue,
                    ...(status === 'active' ? styles.infoValueActive : {}),
                }, children: [status === 'active' && _jsx("span", { style: styles.statusDot }), value] })] }));
}
/** 快捷操作卡片组件 */
function ActionCard({ icon, title, description, color }) {
    const [hover, setHover] = React.useState(false);
    return (_jsxs("div", { style: {
            ...styles.actionCard,
            borderColor: hover ? color : '#e5e7eb',
            boxShadow: hover ? `0 4px 12px ${color}22` : 'none',
        }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), children: [_jsx("div", { style: { ...styles.actionIcon, backgroundColor: `${color}15`, color }, children: icon }), _jsxs("div", { style: styles.actionText, children: [_jsx("span", { style: styles.actionTitle, children: title }), _jsx("span", { style: styles.actionDesc, children: description })] }), _jsx("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "#9ca3af", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("polyline", { points: "9 18 15 12 9 6" }) })] }));
}
const styles = {
    panel: {
        maxWidth: '720px',
        margin: '0 auto',
        padding: '32px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        padding: '24px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '16px',
        marginBottom: '32px',
        color: 'white',
    },
    avatarWrapper: {
        flexShrink: 0,
    },
    avatar: {
        width: '72px',
        height: '72px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        border: '3px solid rgba(255,255,255,0.4)',
    },
    userInfo: {
        flex: 1,
    },
    username: {
        margin: '0 0 4px 0',
        fontSize: '24px',
        fontWeight: 700,
        color: 'white',
    },
    userEmail: {
        margin: '0 0 8px 0',
        fontSize: '14px',
        opacity: 0.85,
        color: 'rgba(255,255,255,0.9)',
    },
    badge: {
        display: 'inline-block',
        padding: '2px 10px',
        backgroundColor: 'rgba(255,255,255,0.2)',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500,
        border: '1px solid rgba(255,255,255,0.3)',
    },
    infoSection: {
        marginBottom: '32px',
    },
    sectionTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '16px',
        fontWeight: 600,
        color: '#1f2937',
        margin: '0 0 16px 0',
    },
    sectionIcon: {
        fontSize: '18px',
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '16px',
    },
    infoItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        padding: '16px',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        border: '1px solid #f3f4f6',
        transition: 'border-color 0.2s',
    },
    infoLabel: {
        fontSize: '13px',
        color: '#6b7280',
        fontWeight: 500,
    },
    infoValue: {
        fontSize: '15px',
        color: '#111827',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    infoValueActive: {
        color: '#059669',
    },
    statusDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#10b981',
        display: 'inline-block',
    },
    actionSection: {},
    actionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
    },
    actionCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    actionIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    actionText: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    actionTitle: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#1f2937',
    },
    actionDesc: {
        fontSize: '12px',
        color: '#9ca3af',
    },
};
//# sourceMappingURL=profile-panel.js.map